import { useCallback, useState } from 'react';
import { useWazuhScope } from 'src/mindtime/hooks/useWazuhScope';
import logger from 'src/utils/logger';
import { fetchWazuhClientCompanies } from './wazuhClientCompanies';
import type { SecuritySearchableFilterOption } from './SecuritySearchableFilter';

export const useWazuhClientFilterOptions = (enabled = true) => {
  const { resellerId } = useWazuhScope();
  const [options, setOptions] = useState<SecuritySearchableFilterOption[]>([]);
  const [loading, setLoading] = useState(false);

  const onSearch = useCallback(
    async (query: string) => {
      if (!enabled || !resellerId) {
        setOptions([]);
        return;
      }

      setLoading(true);
      try {
        const companies = await fetchWazuhClientCompanies(resellerId, query.trim(), 0, 25);
        setOptions(
          companies.map((company) => ({
            value: company.id,
            label: company.name,
          }))
        );
      } catch (error) {
        logger(error, 'error', 'useWazuhClientFilterOptions');
        setOptions([]);
      } finally {
        setLoading(false);
      }
    },
    [enabled, resellerId]
  );

  return { options, loading, onSearch };
};
